const validate = values => {
  const errors = {}

  if (values?.price && values?.fee && values?.price < values?.fee) {
    errors.fee = "The fee is higher that the actual price!"
  }

  if (values?.percentage) {
    if (values?.percentage < 0) {
      errors.percentage = "The min percentage is 0"
    }
    if (values?.percentage > 100) {
      errors.percentage = "The max percentage is 100"
    }
  }

  if (!values?.mainAccPercentage && !values?.mainAccFee) {
    errors.mainAccPercentage = "The percentage is required"
    errors.mainAccFee = "The fee is required"
  }

  if (values?.mainAccPercentage) {
    if (values?.mainAccPercentage < 0) {
      errors.mainAccPercentage = "The min percentage is 0"
    }
    if (values?.mainAccPercentage > 100) {
      errors.mainAccPercentage = "The max percentage is 100"
    }
  }

  if (values?.clientAccounts && values?.clientAccounts?.length > 0) {
    values.clientAccounts?.forEach((account, index) => {
      if (isNaN(parseInt(account?.percentage)) && !account?.fee) {
        errors.clientAccounts = {
          ...errors?.clientAccounts,
          [`${index}`]: {
            percentage: "The percentage is required",
            fee: "The fee is required",
          },
        }
      }
      if (account?.percentage) {
        if (account?.percentage < 0) {
          errors.clientAccounts = {
            ...errors?.clientAccounts,
            [`${index}`]: {
              percentage: "The min percentage is 0",
            },
          }
        }
        if (account?.percentage > 100) {
          errors.clientAccounts = {
            ...errors?.clientAccounts,
            [`${index}`]: {
              percentage: "The max percentage is 100",
            },
          }
        }
      }
    })
  }
  return errors
}

export default validate
